// GFMP-Kandake canonical enums (mirrors backend models.py)

// Admin Walk-Through Correction — Beta Tester and Legal Review are now active
// internal roles. Industry Access remains parked for a future phase.
export const ACTIVE_ROLES = [
  "super_admin",
  "gfmp_reviewer",
  "catalog_manager",
  "legal_review",
  "beta_tester",
];

// Roles that may perform general write operations (create/edit) on canonical
// entities. Used by the frontend to hide write CTAs from read-only roles.
export const WRITER_ROLES = ["super_admin", "gfmp_reviewer", "catalog_manager"];

// Roles authorised for compliance / attorney-review actions.
export const COMPLIANCE_REVIEW_ROLES = ["super_admin", "gfmp_reviewer", "legal_review"];

export const CLEARANCE_STATUSES = [
  "Incomplete",
  "Needs Review",
  "Internally Ready",
  "Client-Ready",
  "Corporate-Ready",
  "Attorney Review Required",
  "Restricted",
  "Ineligible",
];
export const READY_STATUSES = ["Client-Ready", "Corporate-Ready"];

export const DOC_TYPES = [
  "Split Sheet",
  "Letter of Direction / LOD",
  "Admin Agreement",
  "Master Ownership Confirmation",
  "Producer Agreement",
  "Work for Hire",
  "LOC Certificate",
  "DACR Certificate",
  "Sample Clearance",
  "Featured Artist Release",
  "Side Artist Release",
  "Stem Delivery Confirmation",
  "Clean Version Confirmation",
  // Kandake Document Repository (Locked Spec) — expanded vocabulary.
  "Copyright Filing Receipt",
  "Assignment / Transfer of Copyright",
  "Co-Publisher / Third-Party Admin Authority",
  "Master Assignment / Transfer",
  "Sound Recording License",
  "Beat / Production License",
  "Artist Agreement",
  "Artwork Ownership / License",
  "Cover / Mechanical Authorization",
  "Rights-Control Confirmation",
  "One-Stop Confirmation",
  "Executed Sync License",
  "Master Use License",
  "Licensing Agreement",
  "Other",
];

export const DOC_STATUSES = [
  "Missing",
  "Requested",
  "Received",
  "Under Review",
  "Accepted",
  "Rejected",
  "Attorney Review Required",
  "Archived Offline",
  // Kandake Document Repository (Locked Spec) — vault statuses.
  "Uploaded",
  "Verified / Approved",
  "Superseded",
  "Expired",
];

export const LICENSE_REQUEST_STATUSES = [
  "New",
  "In Review",
  "Need More Information",
  "Matched to Track",
  "Pending Approval",
  "Approved for Submission",
  "Declined",
  "Closed",
];

export const SUBMISSION_STATUSES = [
  "Draft",
  "Internal Review",
  "Ready to Send",
  "Sent",
  "Shortlisted",
  "Passed",
  "Selected",
  "Negotiating",
  "Closed",
];

// MP7 — Submission packet/result/deal taxonomy
export const RESULT_STATUSES = [
  "Not Submitted",
  "Submitted",
  "Shortlisted",
  "Passed",
  "Selected",
  "Waiting",
  "No Response",
];

export const DEAL_STATUSES = [
  "None",
  "Pending",
  "Contract Sent",
  "Signed",
  "Paid",
  "Closed",
];

export const DOCUMENT_PACKET_STATUSES = [
  "Not Started",
  "In Progress",
  "Ready",
  "Needs Review",
  "Attorney Review Required",
  "Archived Offline",
];

export const MEDIA_TYPES = [
  "All Media", "TV", "Film", "Streaming", "Online", "Social", "Radio", "Theatrical", "Corporate / Industrial", "Other",
];

// MP6 — License Request taxonomy
export const PROJECT_TYPES = [
  "Film",
  "TV",
  "Streaming Series",
  "Documentary",
  "Advertisement",
  "Trailer",
  "Social Media Campaign",
  "Podcast",
  "YouTube / Online Video",
  "Game",
  "Corporate Video",
  "Other",
];

export const USAGE_TYPES = [
  "Sync License",
  "Master Use",
  "Beat License",
  "Instrumental Use",
  "Background Use",
  "Theme / Title Use",
  "Trailer Use",
  "Festival / Event Use",
  "Custom Inquiry",
  "Other",
];

export const EXPLICIT_CLEAN = ["Clean", "Explicit", "Clean Version Available", "Instrumental Only", "Needs Review"];

// MP4 — refined rights status enums
export const MASTER_STATUS_OPTIONS = ["Unknown", "Claimed", "Confirmed", "Needs Review", "Disputed", "Restricted"];
export const PUBLISHING_STATUS_OPTIONS = ["Unknown", "Claimed", "Confirmed", "Needs Review", "Disputed", "Restricted"];
export const SYNC_RIGHTS_STATUS_OPTIONS = ["Unknown", "Available", "Needs Review", "Restricted", "Not Available"];
export const MECHANICAL_STATUS_OPTIONS = ["Unknown", "Claimed", "Confirmed", "Needs Review", "Disputed", "Restricted"];

// Correction Prompt — Music admin / compliance dropdowns.
// These fields support internal compliance review only. Neither MLC nor HFA grants
// master rights; master permission must come from the master owner, label, or rights holder.
export const SONGTRUST_STATUS_OPTIONS = [
  "Verified", "Not Verified", "Pending", "Not Applicable", "Needs Review",
];
export const SOUNDEXCHANGE_STATUS_OPTIONS = [
  "Verified", "Not Verified", "Pending", "Not Applicable", "Needs Review",
];
export const MLC_STATUS_OPTIONS = [
  "Verified", "Not Verified", "Pending", "Not Applicable", "Needs Review",
];
export const HFA_STATUS_OPTIONS = [
  "Licensed", "Not Licensed", "Pending", "Not Applicable", "Direct License Needed", "Needs Review",
];
export const MECHANICAL_LICENSE_SCOPE_OPTIONS = [
  "DSP Blanket / MLC",
  "HFA Songfile",
  "HFA eMechanical",
  "Direct Publisher License",
  "Foreign Society",
  "Not Applicable",
  "Needs Review",
];

// Backward-compat: kept so any existing data renders. New writes use the MP4 lists above.
export const RIGHTS_STATUSES = ["", "Owned", "Co-Owned", "Administered", "Unknown", "Disputed"];

// MP4 — suggested catalog codes (free entry still allowed).
export const CATALOG_CODE_SUGGESTIONS = ["GFMP", "KW", "LEGACY", "EMM", "CINEMATIC", "CLM"];

// MP4 — mood tag suggestions. Multi-select with custom-add still allowed.
export const MOOD_TAGS = [
  "celebratory", "confident", "dark", "dreamy", "driving", "emotional",
  "empowering", "energetic", "hopeful", "inspirational", "intimate", "joyful",
  "melancholic", "nostalgic", "peaceful", "playful", "reflective", "romantic",
  "sexy", "suspenseful", "tender", "tense", "upbeat", "uplifting",
];
